import React from 'react'
import styled from '@emotion/styled'
import {
  LoadingBar,
  LoadingBarContainer,
  LoadingContent,
  LoadingLogo,
  LoadingWrapper,
} from './styled'

function LoadingFallback() {
  return (
    <LoadingWrapper>
      <LoadingContent>
        <LoadingLogo />
        <LoadingBarContainer>
          <LoadingBar />
        </LoadingBarContainer>
      </LoadingContent>
    </LoadingWrapper>
  )
}

export default LoadingFallback
